<template>

  <div class="list--view">
    <div class="single--list-view single--list-view-employees">
      <vs-select
          class="selectExample"
          v-model="selectTypeRoles"
          @input="statusSelected"
      >
        <vs-select-item
            :is-selected="item.isSelected"
            :key="index"
            :value="item.value"
            :text="item.label"
            v-for="(item,index) in optionsTypeRoles" />
      </vs-select>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      selectTypeRoles: (location.search.indexOf("closed") >= 0 && /closed=([^&]+)/.exec(location.href)[1] === "true") ? "complete" : "actual",
      optionsTypeRoles:[
        {value: 'actual', label: 'Attuali', isSelected: false },
        {value: 'complete', label: 'Completate', isSelected: false },
      ],


    }
  },
  methods: {
    statusSelected(selectedOption, id) {
      if (selectedOption == "actual") {
        location.href = app.__vue__.addParam("closed", "false");
      } else if (selectedOption == "complete") {
        location.href = app.__vue__.addParam("closed", "true");
      }
    },

  },

}
</script>